export enum QuestionOptionEnum {
  OPTION_A = "option_a",
  OPTION_B = "option_b",
  OPTION_C = "option_c",
  OPTION_D = "option_d",
}
